import { render, staticRenderFns } from "./graduate.vue?vue&type=template&id=0b063dc6"
import script from "./graduate.vue?vue&type=script&lang=js"
export * from "./graduate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports